import { ButtonActionTypeEnum } from 'common/enums/ButtonActionTypeEnum'
import { useDelay } from 'publisher/hooks/useDelay'
import React from 'react'
import { DownloadFileButton } from 'src/publisher/entities/button-new/download-file-button'
import { OpenUrlButton } from 'src/publisher/entities/button-new/open-url-button'
import ShowPopupButton from 'src/publisher/entities/button-new/show-popup-button'
import { WebsiteButtonEntityInterface } from 'src/shared/entities/website-button/website-button.schema'

export interface WebsiteButtonProps {
  entity: WebsiteButtonEntityInterface
}

export const WebsiteButton = ({ entity }: WebsiteButtonProps) => {
  const isVisible = useDelay(entity.delay)

  if (!isVisible) {
    return <div />
  }

  switch (entity.action) {
    case ButtonActionTypeEnum.WebsitePageLink:
    case ButtonActionTypeEnum.OpenUrl:
      return <OpenUrlButton entity={entity} />
    case ButtonActionTypeEnum.DownloadFile:
      return <DownloadFileButton entity={entity} />
    case ButtonActionTypeEnum.ShowPopup:
      return <ShowPopupButton entity={entity} />
    default:
      return <div />
  }
}
